import { ModalBaseDirective } from '$core/base/_modal.component';
import { Component } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { Batch } from '../../models';

export interface BatchCommit {
  link: 'blanks' | 'batches';
  isCreateBlanks: boolean;
}

@Component({
  selector: 'app-batch-commited',
  templateUrl: './batch-commited.component.html',
  styleUrls: ['./batch-commited.component.scss'],
})
export class BatchCommitedComponent extends ModalBaseDirective {
  public readonly item: Batch;
  public readonly onClose: Subject<BatchCommit> = new Subject<BatchCommit>();
  public blankControl: FormControl = this._fb.control(false);

  constructor(
    protected readonly modalRef: BsModalRef,
    protected readonly modalService: BsModalService,
    protected readonly translateService: TranslateService,
    private readonly _fb: FormBuilder
  ) {
    super(modalRef, modalService, translateService);
  }

  public close(link: BatchCommit['link']): void {
    this.onClose.next({
      link,
      isCreateBlanks: this.blankControl.value,
    });
    this.hide();
  }
}
